/* eslint-disable jsx-a11y/tabindex-no-positive */
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '~/ui/components/common/Button';

import styles from './FormActions.module.scss';

interface IProps {
  isProcessing: boolean;
  submitText: string;
}

const FormActions = ({ isProcessing, submitText }: IProps): ReactElement => {
  const navigate = useNavigate();

  return (
    <div className={styles.buttonsWrapper}>
      <div className={styles.buttonWrapper}>
        <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
          Cancel
        </Button>
      </div>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={isProcessing}
        tabIndex={23}
      >
        {submitText}
      </Button>
    </div>
  );
};

export default FormActions;
